var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-progress-circular',{staticClass:"fetchingData",attrs:{"size":_vm.size?_vm.size:50,"color":_vm.color?_vm.color:'amber',"indeterminate":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }